import { useCallback } from "react";
import { Summary } from "devextreme-react/cjs/data-grid";
import { DashCard } from "../../../../script/components/dash-board/dash-card/dash-card";
import { ScrollGrid } from "../../../../script/components/data-grid/data-grid-body/grid-bodys";
import { CommCol, DateCol, DeciCol } from "../../../../script/components/data-grid/data-grid-column/grid-column";
import { GroupSumItem, TotalCntItem } from "../../../../script/components/data-grid/data-grid-body/grid-body-item";
import { CommChart } from "../../../../script/components/chart/charts";
import { BarsSeri, CommAxis } from "../../../../script/components/chart/charts-item";
import { fwUtil } from "../../../../script/util";

const equiGroupRender = (data) => {

    if (!data && (data && data.length < 1)) {
        return;
    }

    if (!data.summaryItems) {
        return;
    }
    const cntsColumn = data?.totalItem?.cells?.length;
    const kwonColumn = data?.summaryItems[0];

    if (!cntsColumn || !kwonColumn) {
        return;
    }

    return (
        <div className='fw-summary-group'>
            <div className='fw-group-title'>
                {data.displayValue}
            </div>
            <div className='fw-group-detail'>
                총 <b>{cntsColumn}</b> 건
            </div>
            <div className='fw-group-detail'>
                총 {kwonColumn.columnCaption} : <b>{fwUtil.conv.to.krLocales(kwonColumn.value)}</b> 건
            </div>
        </div>
    )
}

export function DashMainCard(props) {
    const { loading, data, subsData, clickNameChange } = props;

    const tooltipTamplate = (arg) => {
        //const argument = arg.argument;
        //const equiNumb = argument.substring(0, 10);
        /* let mainNumb = "";
        for(let i = 0; i < subsData.length; i++) {
            const items = subsData[i];
            if (items.main_numb === equiNumb) {
                mainNumb = items.main_numb;
                break;
            }
        } */
        return {
            text: `${arg.seriesName} : ${fwUtil.conv.to.krLocales(arg.value)} (W)`,
        };
    };

    const onClick = (e, gubu) => {
        if (gubu) {
            const argument = e.argument;
            const equiNumb = argument.substring(0, 10);
            clickNameChange(equiNumb);
        } else {
            const argument = e.target.argument;
            const equiNumb = argument.substring(0, 10);
            clickNameChange(equiNumb);
        }
    };

    return (
        <DashCard
            //title={"설비별 고장 및 평균 전력 사용 현황"}
            title={"설비별 사용 현황"}
            addClass={'main'}
            loading={loading}
        >
            <ScrollGrid
                gridDataSource={subsData}
                width={1050}
                height={250}
                //mainKey={["equi_numb", "main_seri"]}
                mainKey={["main_numb"]}
                selection={'single'}
                direction={'vertical'}
            >
                {/*  {CommCol({ dataField: "equi_numb", caption: "설비번호", groupIndex: 0, groupRender: equiGroupRender })}
                {CommCol({ dataField: "equi_name", caption: "설비명" })}
                {CommCol({ dataField: "main_seri", caption: "점검순번" })}
                {DateCol({ dataField: "main_date", caption: "점검일자" })}
                {DeciCol({ dataField: "main_kwon", caption: "수리/부품비" })}
                {CommCol({ dataField: "brok_desc", caption: "고장내역" })}
                {CommCol({ dataField: "main_desc", caption: "정비내역" })} */}
                {CommCol({ dataField: "main_numb", caption: "설비번호" })}
                {CommCol({ dataField: "equi_name", caption: "설비명" })}
                {CommCol({ dataField: "equi_seno", caption: "기기번호" })}
                {CommCol({ dataField: "usag_elec", caption: "평균사용량(W)" })}
                <Summary>
                    {TotalCntItem({ dataField: "equi_numb", caption: "정비", suffix: "건" })}
                    {GroupSumItem({ dataField: "main_kwon", suffix: "원" })}
                </Summary>                
            </ScrollGrid>
            <div style={{ paddingLeft: 20 }}></div>
            <CommChart
                dataSource={subsData}
                tooltip={{ location: "edge", template: tooltipTamplate }}
                onArgumentAxisClick={(e) => onClick(e, true)}
                onPointClick={(e) => onClick(e, false)}
            >
                {CommAxis({ name: "elec", caption: "월평균 사용전력(W)", position: "left", start: 0 })}
                {BarsSeri({ valueField: "usag_elec", caption: "평균사용전력량", color: "#4EACFF",  args: "main_name", axis: "elec" })}      
            </CommChart>
        </DashCard>
    )
}